module.exports = __webpack_public_path__ + "img/level_two.40f12eed.png";